<template>
  <q-dialog
    :ref="modalRef"
    v-cloak
    :full-width="windowWidth <= 1025"
    :position="windowWidth <= 1025 ? 'bottom' : 'standard'"
    full-height
    @hide="
      () => {
        hide();
      }
    "
  >
    <q-card class="listing">
      <div class="listing__top-bar">
        <q-btn
          round
          color="background-very-very-light"
          class="--shadow__bottom --bordered"
          @click="
            () => {
              hide();
            }
          "
          no-caps
        >
          <q-icon name="sym_r_close" size="24px" />
          <q-tooltip
            anchor="center right"
            self="center left"
            max-width="300px"
            :offset="[6, 6]"
            persistent
          >
            Back to Search
          </q-tooltip>
        </q-btn>
      </div>

      <div v-if="vehicleLoaded && !loading" class="listing__content">
        <div class="listing__main-content q-gutter-y-lg">
          <div class="full-width q-mt-sm" style="margin-bottom: -6px">
            <q-card
              v-if="windowWidth > 769"
              class="bg-background-light q-pa-md q-mt-md"
            >
              <div class="column items-start justify-between">
                <div>
                  <h4
                    v-html="vehicle.title_raw"
                    class=" q-mb-none"
                    style="font-weight: 900 !important;"
                  />
                  <div
                    class="flex items-center no-wrap ellipsis text-weight-medium text-text-light"
                    style="margin-top: 5px"
                  >
                    <q-icon name="sym_r_speed" size="20px" class="q-mr-xs" />
                    <p
                      v-html="vehicle.mileage_formatted + ' miles'"
                      class="ellipsis"
                    />
                  </div>
                </div>
                <div class="flex items-center justify-start q-mt-md">
                  <div class="row no-wrap items-start">
                    <h3 class="text-primary q-mb-none" style="font-weight: 800">
                      {{ vehicle.price_formatted }}
                    </h3>
                    <PriceDropLabel
                      v-if="
                        vehicle.tags.filter(tag => tag.tag === 'Price Drop')
                          .length > 0
                      "
                      :amount-change="
                        vehicle.tags.filter(tag => tag.tag === 'Price Drop')[0]
                          .metadata.amount_change
                      "
                      class="q-ml-xs"
                    />
                  </div>
                  <div
                    class="row no-wrap items-end justify-end q-mb-none q-ml-md"
                    style="white-space: nowrap;"
                  >
                    <p
                      class="--text-md text-text-light"
                      style="border-bottom: 1px solid #9e9e9e70; margin-bottom: -6px"
                    >
                      Est. ${{ vehicle.estimated_monthly_payment }}/mo*
                      <q-tooltip
                        anchor="bottom right"
                        self="top right"
                        :offset="[6, 6]"
                        max-width="300px"
                      >
                        Monthly payment estimate of ${{
                          vehicle.estimated_monthly_payment
                        }}
                        is based on a 72 month loan at 5.2% APR with a 20% down
                        payment.
                      </q-tooltip>
                    </p>
                  </div>
                </div>
              </div>
            </q-card>
            <q-card v-else class="bg-background-light q-mt-md">
              <q-card-section>
                <div>
                  <div class="ellipsis">
                    <h4
                      v-html="vehicle.title_raw"
                      class="ellipsis --no-style q-mb-none"
                      style="font-weight: 900 !important;"
                    />
                    <div
                      class="flex items-center no-wrap ellipsis text-weight-medium text-text-light"
                      style="margin-top: 4px"
                    >
                      <q-icon name="sym_r_speed" size="19px" class="q-mr-xs" />
                      <p
                        v-html="vehicle.mileage_formatted + ' miles'"
                        class="ellipsis"
                      />
                    </div>
                  </div>

                  <div class="flex items-center q-mt-md">
                    <div class="flex no-wrap items-start">
                      <h3
                        class="text-primary q-mb-none"
                        style="font-weight: 800"
                      >
                        {{ vehicle.price_formatted }}
                      </h3>
                      <PriceDropLabel
                        v-if="
                          vehicle.tags.filter(tag => tag.tag === 'Price Drop')
                            .length > 0
                        "
                        :amount-change="
                          vehicle.tags.filter(
                            tag => tag.tag === 'Price Drop'
                          )[0].metadata.amount_change
                        "
                        class="q-ml-sm"
                        style="margin-top: -2px"
                      />
                    </div>
                    <div
                      class="row no-wrap items-center justify-start q-mb-none q-ml-sm"
                      style="white-space: nowrap;"
                    >
                      <p
                        class="text-text-light"
                        style="border-bottom: 1px solid #9e9e9e70; margin-bottom: -8px"
                      >
                        Est. ${{ vehicle.estimated_monthly_payment }}/mo*
                        <q-tooltip
                          anchor="bottom right"
                          self="top right"
                          :offset="[6, 6]"
                          max-width="300px"
                        >
                          Monthly payment estimate of ${{
                            vehicle.estimated_monthly_payment
                          }}
                          is based on a 72 month loan at 5.2% APR with a 20%
                          down payment.
                        </q-tooltip>
                      </p>
                    </div>
                  </div>
                </div>
              </q-card-section>

              <!--<q-separator inset />

              <q-card-section>
                <div
                    class="flex no-wrap items-end justify-between q-gutter-x-sm"
                >
                  <div class="ellipsis --text-sm">
                    <p
                        class="flex items-center no-wrap --no-style q-mb-none text-weight-medium ellipsis"
                    >
                      <q-icon
                          name="sym_r_place"
                          class="q-mr-xs"
                          size="15px"
                      />
                      <span
                          v-html="
                            vehicle.dealer.city + ', ' + vehicle.dealer.state
                          "
                          class="ellipsis"
                      />
                    </p>
                    <p
                        v-if="'distance' in vehicle"
                        class="ellipsis text-text-light"
                    >
                      {{ vehicle.distance + " miles away" }}
                      <span class="q-mx-xs">&#8226;</span>
                      {{ vehicle.dealer.name }}
                    </p>
                  </div>
                </div>
              </q-card-section>-->
            </q-card>
          </div>

          <div class="relative-position">
            <div
              class="vehicle-card__badges flex items-center justify-start q-gutter-sm"
              style="position: absolute; top: 10px; left: 10px; z-index: 2"
            >
              <HighlightBadge
                v-for="(tagData, i) in vehicle.tags.filter(
                  tag => tag.tag !== 'Price Drop'
                )"
                :key="i + '_vehicleTagDataBadge'"
                :label="tagData.tag"
                :color="
                  {
                    'Price Drop': 'positive',
                    'New Listing': 'blue'
                  }[tagData.tag]
                "
                style="box-shadow: 0 1px 4px rgba(1, 1, 1, 0.3), 0 2px 4px rgba(1, 1, 1, 0.2), 0 3px 3px -4px rgba(1, 1, 1, 0.18); border-radius: 12px; font-size: 11px"
              />
            </div>
            <ImageCarouselGrid
              :images="vehicle.images"
              hover-effect
              :max-grid-columns="windowWidth > 1035 ? 3 : null"
            />
          </div>

          <q-card ref="detailsCard" class="listing__content-card">
            <q-card-section>
              <div class="row q-col-gutter-md">
                <div
                  v-for="detail in vehicleDetailsListData"
                  :key="detail.label + '_vehicleDetailItem'"
                  class="col-12 col-md-6"
                >
                  <div class="listing__vehicle-details-list-item">
                    <div
                      v-if="detail.colorCircle"
                      class="listing__vehicle-details-color-circle"
                      :style="{ backgroundColor: detail.colorCircle }"
                    ></div>
                    <q-icon
                      v-else
                      :name="detail.icon"
                      size="22px"
                      class="listing__vehicle-details-icon text-text-light"
                    />
                    <p
                      v-html="detail.display"
                      class="q-mb-none text-weight-medium"
                    ></p>
                  </div>
                </div>
              </div>
            </q-card-section>

            <q-card-section
              v-if="vehicleFeaturesEnabled.length > 0"
              class="q-pt-none q-pb-sm"
            >
              <div
                class="flex items-center justify-center q-mb-sm relative-position"
                style="margin-left: -4px"
              >
                <q-btn
                  dense
                  no-caps
                  color="background-light"
                  text-color="text-light"
                  @click="showAllFeatures = !showAllFeatures"
                  class="text-weight-medium no-shadow"
                  style="z-index: 2; padding-left: 20px; padding-right: 20px;"
                >
                  {{
                    showAllFeatures
                      ? "Hide All Features"
                      : "View All " +
                        Object.values(this.vehicle.features).filter(v => v == 1)
                          .length +
                        " Features"
                  }}
                  <q-icon
                    :name="
                      showAllFeatures
                        ? 'sym_r_keyboard_arrow_up'
                        : 'sym_r_keyboard_arrow_down'
                    "
                    size="20px"
                    class="q-ml-xs"
                  />
                </q-btn>
                <div
                  class="--border-bottom"
                  style="position: absolute; top: 15px; left: 6px; width: calc(100% - 12px);"
                ></div>
              </div>

              <q-slide-transition>
                <div
                  v-show="showAllFeatures"
                  class="row justify-between items-start"
                >
                  <q-item
                    v-for="(feature, i) in vehicleFeaturesEnabled"
                    :key="i + '_vehicleFeatureItem'"
                    class="col-12 col-md-6 q-pl-none"
                    dense
                  >
                    <div class="row no-wrap items-center">
                      <div
                        class="q-mr-md bg-text-light"
                        style="width: 5px; height: 5px; border-radius: 50%;"
                      ></div>
                      <p v-html="feature" class="q-mb-none"></p>
                    </div>
                  </q-item>
                </div>
              </q-slide-transition>
            </q-card-section>
          </q-card>

          <VehicleDealScoreDetails
            :product-id="vehicle.product_id"
            :mileage="vehicle.mileage"
            :price="vehicle.price"
          />

          <VehiclePriceHistory
            :product-id="vehicle.product_id"
            :price="vehicle.price"
          />

          <q-card ref="dealerInfoCard" class="listing__content-card">
            <q-card-section>
              <div class="flex items-center">
                <q-icon
                  name="sym_r_store"
                  size="26px"
                  class="q-mr-sm"
                  style="margin-top: -3px"
                />
                <h5 class="q-ma-none text-weight-bold q-mb-xs">
                  {{ vehicle.dealer.name }}
                </h5>
              </div>
              <div class="q-mt-xs">
                <p class="q-ma-none text-text-light">
                  {{ vehicle.dealer.address }}
                </p>
                <p class="q-ma-none text-text-light" style="margin-top: -3px">
                  {{ vehicle.dealer.city }}, {{ vehicle.dealer.state }}
                  {{ vehicle.dealer.postal_code }}
                </p>
              </div>
            </q-card-section>
            <q-card-section class="q-pt-none">
              <div class="--shadow__bottom --rounded" style="height: 366px">
                <iframe
                  width="100%"
                  height="366"
                  style="border:0; filter: brightness(0.9); border-radius: 14px"
                  loading="lazy"
                  allowfullscreen
                  :src="
                    'https://www.google.com/maps/embed/v1/place?key=AIzaSyBchU_pFfwvEIGYVQivG_BXO3EsiX0Bnw0&zoom=10&q=' +
                      encodeURI(vehicle.dealer.name) +
                      ', ' +
                      encodeURI(vehicle.dealer.city) +
                      ', ' +
                      encodeURI(vehicle.dealer.state)
                  "
                >
                </iframe>
              </div>
            </q-card-section>
            <q-card-section
              v-if="
                vehicle.description.length > 0 &&
                  vehicle.description.indexOf(
                    vehicle.year +
                      ' ' +
                      vehicle.make_raw +
                      ' ' +
                      vehicle.model_raw
                  ) !== 0
              "
              class="q-pt-none"
            >
              <div class="text-weight-bold --text-sm q-mb-xs">
                Notes from the seller:
              </div>
              <p
                class="text-text-light --text-sm"
                v-html="vehicle.description"
              />
            </q-card-section>
          </q-card>
        </div>

        <div class="listing__bottom-bar">
          <div
            class="flex items-center justify-center"
            :style="[windowWidth <= 769 ? { 'flex-wrap': 'wrap-reverse' } : {}]"
            :class="{
              'q-gutter-md': windowWidth > 769,
              'q-gutter-sm': windowWidth <= 769
            }"
          >
            <!--<q-btn
              v-if="windowWidth > 769"
              rounded
              color="background-very-very-light"
              class="--shadow__bottom --bordered"
              @click="
                () => {
                  promptVehicleInsightsDialog();
                }
              "
              no-caps
            >
              <q-icon
                name="sym_r_auto_awesome"
                size="20px"
                style="margin-bottom: -1px; margin-left: -3px"
                class="q-mr-sm"
              />
              <div>Ask CarScience</div>
            </q-btn>
            <q-btn
              v-else
              round
              color="background-very-very-light"
              class="--shadow__bottom --bordered"
              @click="
                () => {
                  promptVehicleInsightsDialog();
                }
              "
              icon="sym_r_auto_awesome"
            >
              <q-tooltip
                anchor="bottom middle"
                self="top middle"
                max-width="300px"
                :offset="[6, 6]"
                persistent
              >
                View AI Insights
              </q-tooltip>
            </q-btn>
            <q-space v-if="windowWidth > 769" />-->

            <VehicleShareButton
              :vehicle="vehicle"
              class="--bordered bg-background-very-very-light"
            />

            <VehicleWatchlistButton
              :product-id="productId"
              class="--bordered bg-background-very-very-light"
            />
            <!--<q-btn
              v-if="windowWidth > 769"
              rounded
              type="submit"
              color="secondary"
              @click="promptLeadFormDialog"
              no-caps
            >
              <q-icon
                name="sym_r_phone"
                size="20px"
                style="margin-bottom: -1px; margin-left: -3px"
                class="q-mr-sm"
              />
              <div>Call Dealer</div>
            </q-btn>
            <q-btn
              v-else
              round
              type="submit"
              color="secondary"
              @click="promptLeadFormDialog"
              icon="sym_r_phone"
            >
              <q-tooltip
                  anchor="bottom middle"
                  self="top middle"
                  max-width="300px"
                  :offset="[6,6]"
                  persistent
              >
                Call Dealership
              </q-tooltip>
            </q-btn>-->
            <q-btn
              rounded
              type="submit"
              color="secondary"
              @click="
                () => {
                  if (vehicle.conversion_goal_event_type_id == 3) {
                  } else {
                    promptLeadFormDialog();
                  }
                }
              "
              class="col"
              no-caps
            >
              <div>Check Availability</div>
              <q-icon
                :name="
                  vehicle.conversion_goal_event_type_id == 3
                    ? 'sym_r_north_east'
                    : 'sym_r_forum'
                "
                size="20px"
                class="q-ml-sm"
              />
            </q-btn>
          </div>
        </div>
      </div>

      <div v-else-if="loading" class="listing__placeholder">
        <div class="column q-gutter-y-lg q-mt-none" style="width: 100%">
          <q-skeleton
            height="140px"
            width="100%"
            animation="fade"
            style="margin-top: 10px"
          />
          <q-skeleton height="50vh" width="100%" animation="fade" />
          <q-skeleton height="500px" width="100%" animation="fade" />
          <q-skeleton height="500px" width="100%" animation="fade" />
        </div>
      </div>

      <div v-if="!vehicleLoaded && !loading">
        <div class="text-weight-bold text-center q-mt-xl">
          <q-icon
            name="sym_r_car_crash"
            style="font-size: 100px"
            class="q-mb-md text-text-light"
          />
          <h5>
            Sorry, this vehicle is no longer available.
          </h5>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";
import { Dialog } from "quasar";
import LeadFormDialog from "@/components/LeadFormDialog.vue";
import ImageCarouselGrid from "@/components/UI/ImageCarouselGrid.vue";
// import VehicleInsightsDialog from "@/components/VehicleInsightsDialog.vue";
// import PricingLeaderboardDialog from "@/components/PricingLeaderboardDialog.vue";
import PriceDropLabel from "@/components/UI/PriceDropLabel.vue";
import VehicleDealScoreDetails from "@/components/VehicleDealScoreDetails.vue";
import VehiclePriceHistory from "@/components/VehiclePriceHistory.vue";
import VehicleWatchlistButton from "@/components/VehicleWatchlistButton.vue";
import VehicleShareButton from "@/components/VehicleShareButton.vue";
import HighlightBadge from "@/components/UI/HighlightBadge.vue";

export default {
  name: "ListingDialog",
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  components: {
    HighlightBadge,
    VehicleShareButton,
    VehicleWatchlistButton,
    VehiclePriceHistory,
    VehicleDealScoreDetails,
    PriceDropLabel,
    ImageCarouselGrid
  },
  data() {
    return {
      modalRef: "ListingDialog",
      loading: true,
      vehicle: {},
      leadSubmitted: false,
      showAllFeatures: false
    };
  },
  computed: {
    vehicleLoaded() {
      return Object.keys(this.vehicle).length > 0;
    },
    vehicleFeaturesEnabled() {
      if (!this.vehicle.features) return [];

      return Object.entries(this.vehicle.features)
        .filter(([key, value]) => key && value === "1")
        .map(([key]) => {
          // Convert snake_case to Title Case
          return key
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
        })
        .sort();
    },
    vehicleDetailsListData() {
      let drivetrainLongMapping = {
        AWD: "All-Wheel Drive",
        FWD: "Front-Wheel Drive",
        RWD: "Rear Wheel Drive"
      };

      return [
        {
          label: "Ext. Color",
          icon: "sym_r_palette",
          colorCircle: this.vehicle.exterior_color
            ? this.vehicle.exterior_color
            : null,
          display:
            (!this.vehicle.exterior_color
              ? "N/A"
              : this.vehicle.exterior_color == "Other"
              ? "Other/Unknown"
              : this.vehicle.exterior_color) + " Exterior"
        },
        {
          label: "Int. Color",
          icon: "sym_r_palette",
          colorCircle: this.vehicle.interior_color
            ? this.vehicle.interior_color
            : null,
          display:
            (!this.vehicle.interior_color
              ? "N/A"
              : this.vehicle.interior_color == "Other"
              ? "Other/Unknown"
              : this.vehicle.interior_color) + " Interior"
        },
        {
          label: "VIN",
          icon: "sym_r_newsmode",
          display: "VIN: " + this.vehicle.vin
        },
        {
          label: "Trim",
          icon: "sym_r_style",
          display:
            "Trim: " + (!this.vehicle["trim"] ? "-" : this.vehicle["trim"])
        },
        {
          label: "Mileage",
          icon: "sym_r_speed",
          display: this.vehicle.mileage_formatted + " miles"
        },
        {
          label: "MPG",
          icon: "sym_r_local_gas_station",
          display:
            !this.vehicle["highway_mpg"] || this.vehicle["highway_mpg"] <= 1
              ? "N/A"
              : this.vehicle["highway_mpg"] +
                " MPG Highway" +
                (this.vehicle.fuel_type
                  ? " (" + this.vehicle.fuel_type + ")"
                  : "")
        },
        {
          label: "Transmission",
          icon: "sym_r_auto_transmission",
          display: !this.vehicle.transmission
            ? "N/A"
            : this.vehicle.transmission + " Transmission"
        },
        {
          label: "Drivetrain",
          icon: "sym_r_search_hands_free",
          display:
            !this.vehicle.drivetrain ||
            !(this.vehicle.drivetrain in drivetrainLongMapping)
              ? "N/A"
              : drivetrainLongMapping[this.vehicle.drivetrain]
        },
        {
          label: "Engine Type",
          icon: "sym_r_valve",
          display: this.vehicle.engine_type + " Engine"
        },
        {
          label: "Features",
          icon: "sym_r_settings_motion_mode",
          display:
            "And " +
            Object.values(this.vehicle.features).filter(v => v == 1).length +
            " features..."
        }
      ];
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getVehicle();

    if (!window.sessionStorage.getItem("srpLastUrlParams")) {
      window.sessionStorage.setItem(
        "srpLastUrlParams",
        this.urlParams().toString()
      );
    }
    window.history.replaceState(history.state, null, "?pid=" + this.productId);
  },
  unmounted() {
    window.history.replaceState(
      history.state,
      null,
      window.sessionStorage.getItem("srpLastUrlParams") &&
        !window.sessionStorage.getItem("srpLastUrlParams").includes("pid=")
        ? "?" + window.sessionStorage.getItem("srpLastUrlParams")
        : "?"
    );
    window.sessionStorage.removeItem("srpLastUrlParams");
  },
  methods: {
    show() {
      this.$refs[this.modalRef].show();
    },
    hide() {
      this.$refs[this.modalRef].hide();
      window.history.replaceState(history.state, null, "?");
    },
    getVehicle() {
      axios
        .post(
          "https://api-v2.jumpfeed.com/network/publisher/products/vehicles",
          {
            filters: [{ product_id: { equals: this.productId } }],
            options: {
              location_search: {
                postal_code: this.$store.state.search.location.postalCode,
                radius: 5000,
                include_distance_field: true
              }
            }
          }
        )
        .then(response => {
          let vehicles = response.data.data.results;

          if (vehicles.length === 0) {
            this.loading = false;
            return;
          }

          setTimeout(() => {
            this.vehicle = vehicles[0];

            this.vehicle["estimated_monthly_payment"] = this.formatNumber(
              this.getEstimatedMonthlyVehiclePayment(this.vehicle.price)
            );

            if (
              Math.abs(
                (new Date(this.vehicle.time_created) - new Date()) / 36e5
              ) < 168
            ) {
              this.vehicle.tags.unshift({
                tag: "New Listing",
                metadata: {},
                time_created: ""
              });
            }

            /* if(this.vehicle.mileage / (((new Date().getFullYear()) - this.vehicle.year) + 0.5) <= 10000) {
              this.vehicle.tags.push({
                tag: "Low Mileage",
                metadata: {},
                time_created: ""
              });
            }
            if(this.vehicle.mileage / (((new Date().getFullYear()) - this.vehicle.year) + 0.5) >= 20000) {
              this.vehicle.tags.push({
                tag: "High Mileage",
                metadata: {},
                time_created: ""
              });
            }*/

            this.loading = false;
          }, 250);
        });
    },
    promptLeadFormDialog() {
      Dialog.create({
        component: LeadFormDialog,
        componentProps: {
          vehicle: this.vehicle
        }
      });
    },
    promptVehicleInsightsDialog() {
      /*Dialog.create({
        component: VehicleInsightsDialog,
        componentProps: {
          year: this.vehicle.year,
          make: this.vehicle.make,
          model: this.vehicle.model,
          trim: this.vehicle.trim
        }
      });*/
    },
    promptPricingLeaderboardDialog(vehicle) {
      console.log(vehicle);
      /*Dialog.create({
        component: PricingLeaderboardDialog,
        componentProps: {
          year: vehicle.year,
          make: vehicle.make,
          model: vehicle.model,
          trim: vehicle.trim,
          radius: vehicle.distance + 25,
          highlightedProductId: vehicle.product_id
        }
      }).onOk(() => {
        this.hide();
      });*/
    },
    navigateBack() {
      document.referrer.includes("carscience.com") ||
      document.referrer.includes("localhost")
        ? this.$router.go(-1)
        : this.$router.push({ path: "/search" });
    }
  }
};
</script>

<style scoped lang="scss">
.listing {
  max-height: 100dvh !important;
  height: 100dvh !important;
  padding: 0;
  width: 680px;
  max-width: 80dvw;
  margin: 0 auto;
  background: color(background);
  position: relative;
  border-radius: 0 !important;
  border-bottom: none !important;
  border-top: none !important;
  &::-webkit-scrollbar {
    display: none;
  }

  @include screen-md {
    width: 100%;
  }

  .listing__top-bar {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: $space-md;
    display: flex;
    flex-direction: row-reverse;
  }

  .listing__content {
    margin-top: -72px;
    width: 100%;
    @include display-flex(column, flex-start, flex-start);

    @include screen-sm {
      margin-top: -64px;
    }

    .listing__main-content {
      width: 100%;
      font-size: 16px;
      padding: $space-lg;

      @include screen-sm {
        padding: $space-md;
      }

      .listing__content-card {
        background: color(background, light);
        border: 1px solid color(border);
      }
    }

    .listing__bottom-bar {
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 3;
      width: 100%;
      padding: $space-lg;
      box-shadow: $shadow-top;
      background: linear-gradient(
        to top,
        color(background),
        #131415c9,
        #0000ff00
      );
      backdrop-filter: blur(3px);
      // box-shadow: $shadow-bottom;
      mask-image: linear-gradient(
        to top,
        transparent 0%,
        black 0%,
        black 85%,
        transparent 100%
      );
      -webkit-mask-image: linear-gradient(
        to top,
        transparent 0%,
        black 0%,
        black 85%,
        transparent 100%
      ); /* For Webkit browsers */

      @include screen-sm {
        padding: $space-lg $space-md;
      }
    }

    .listing__side-content {
      min-width: 310px;
      width: 100%;
      margin-left: $space-md;
      @include full-screen-height;
      position: sticky;
      top: calc(#{$titlebar-height} + #{$space-md});

      @include screen-md {
        display: none;
        min-width: unset;
      }
    }

    .listing__content-card__header {
      /* box-shadow: $shadow-bottom; */
      margin-bottom: $space-xs;
      background: color(background, very-light);

      h5 {
        margin-bottom: 0;
        /*@include display-flex(row, flex-start, center);
        flex-wrap: nowrap;
        font-weight: 800;
        width: fit-content;
        border-bottom: 3px solid color(secondary);
        padding-bottom: $space-md;
        margin: 0 0 -#{$space-md};*/
      }
    }

    .listing__vehicle-details-list-item {
      @include display-flex(row, flex-start, center);
      padding: $space-xs 0;
      gap: $space-sm;

      .listing__vehicle-details-icon {
        flex-shrink: 0;
      }

      .listing__vehicle-details-color-circle {
        width: 21px;
        height: 21px;
        border-radius: 50%;
        flex-shrink: 0;
        border: 2px solid color(border);
      }

      p {
        font-size: 15px;
        line-height: 1.4;
      }
    }
  }

  .listing__placeholder {
    margin: -64px $space-lg $space-xl $space-lg;

    @include screen-md {
      margin-left: $space-md;
      margin-right: $space-md;
    }
  }
}
</style>
